// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lbkW","fullView":"styles_fullView__3DdLp"};